import { useCallback } from 'react';
import { useLazyValidateSlugQuery } from '../../../../store/redux/api/dynamicFormApi';

export const useValidateSlug = (templateId?: string) => {
  const [validateSlugQuery] = useLazyValidateSlugQuery();

  const validateSlug = useCallback(
    async (value: string): Promise<boolean> => {
      if (!value?.trim()) return true;

      try {
        await validateSlugQuery({
          slug: value.trim(),
          templateId: templateId || undefined,
        }).unwrap();
        return true;
      } catch {
        return false;
      }
    },
    [validateSlugQuery, templateId]
  );

  return { validateSlug };
};
